import React, { useEffect, useState } from "react";
import { getFamilies } from "../services/familyService";
import AddFamilyForm from "./AddFamilyForm";
import { FamilyResponse } from "../types/FamilyTypes";
import FamilyTable from "./FamilyTable";

const FamilyList = () => {
  const [families, setFamilies] = useState<FamilyResponse[]>([]);

  useEffect(() => {
    loadFamilies();
  }, []);

  const loadFamilies = async () => {
    const data = await getFamilies();
    setFamilies(data);
  };


  return (
    <div>
      <h1>Family List</h1>
      <AddFamilyForm loadFamilies={loadFamilies} />
      <FamilyTable families={families} loadFamilies={loadFamilies} />
    </div>
  );
};

export default FamilyList;
